module.exports = __webpack_public_path__ + "static/img/pdf.ae6c7ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdf.png
// module id = Ta3C
// module chunks = 0